import { render, staticRenderFns } from "./WorkStationList.vue?vue&type=template&id=2d4e0e2e&"
import script from "./WorkStationList.vue?vue&type=script&lang=js&"
export * from "./WorkStationList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports